"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["ADMINISTRATOR"] = "administrator";
    UserRole["CLIENT"] = "client";
    UserRole["SERVICE_MANAGER"] = "service_manager";
    UserRole["SERVICE_WRITER"] = "service_writer";
    UserRole["APPOINTMENT_COORDINATOR"] = "appointment_coordinator";
    UserRole["REWARDS_ADMINISTRATOR"] = "rewards_administrator";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
//# sourceMappingURL=User.js.map